import React from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useTranslation } from 'react-i18next';
import {
    ORDERED_MONTHS,
    ORDERED_MONTHS_NUMBERS,
} from 'routes/HumanResourcesModule/PayState/helpers/constants';

type Props = {
    selectedMonth: number;
    setSelectedMonth: (newValue: number) => void;
    startMonth?: number;
};

export default function MonthSelector(props: Props): React.ReactElement {
    const { t } = useTranslation();

    const { selectedMonth, setSelectedMonth, startMonth } = props;

    return (
        <Box sx={{ width: '50%', backgroundColor: 'white' }}>
            <FormControl required fullWidth>
                <InputLabel>{t('humanResources.applicationMonth')}</InputLabel>
                <Select
                    value={selectedMonth}
                    onChange={(event) =>
                        setSelectedMonth(event.target.value as number)
                    }
                    label={t('humanResources.applicationMonth')}
                >
                    <MenuItem value="" disabled>
                        {t('humanResources.selectMonth')}
                    </MenuItem>
                    {ORDERED_MONTHS.map((month) => {
                        if (
                            !startMonth ||
                            (startMonth &&
                                ORDERED_MONTHS_NUMBERS[month] > startMonth)
                        ) {
                            return (
                                <MenuItem
                                    value={ORDERED_MONTHS_NUMBERS[month]}
                                    key={month}
                                >
                                    {t(`date.month.${month}`)}
                                </MenuItem>
                            );
                        }
                        return <></>;
                    })}
                </Select>
            </FormControl>
        </Box>
    );
}
